"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.reverse = function (graph) {
    return function (x) {
        return graph(1 - x);
    };
};
exports.mirror = function (graph) {
    return function (x) {
        if (x < 0.5) {
            return graph(x * 2);
        }
        else {
            return graph((1 - x) * 2);
        }
    };
};
exports.inverse = function (graph) {
    return function (x) {
        return 1 - graph(1 - x);
    };
};
exports.pair = function (graphA, graphB) {
    return function (x) {
        if (x < 0.5) {
            return graphA(x * 2) * 0.5;
        }
        else {
            return graphB((x - 0.5) * 2) * 0.5 + 0.5;
        }
    };
};
exports.inOut = function (graph) {
    return exports.pair(graph, exports.inverse(graph));
};
exports.mean = function () {
    var graphs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        graphs[_i] = arguments[_i];
    }
    return function (x) {
        return (utils_1.arrayMean(graphs.map(function (graph) {
            return graph(x);
        })) || 0);
    };
};
exports.sequence = function () {
    var graphs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        graphs[_i] = arguments[_i];
    }
    var length = graphs.length;
    return function (x) {
        var range = x * length;
        var graphIndex = Math.floor(range);
        var graph = graphs[graphIndex];
        var subX = range - graphIndex;
        return graph(subX);
    };
};
exports.set = function () {
    var sets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sets[_i] = arguments[_i];
    }
    return function (x) {
        var y = utils_1.arrayMean(sets
            .map(function (candidate) {
            var _a = __read(candidate, 3), graph = _a[0], start = _a[1], stop = _a[2];
            if (start <= x && stop >= x) {
                var proportionalX = (x - start) / (stop - start);
                return graph(proportionalX);
            }
            return undefined;
        })
            .filter(function (candidate) {
            return candidate !== undefined;
        }));
        return y || 0;
    };
};
